module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<p class="mb-1">'+
((__t=( title ))==null?'':_.escape(__t))+
'</p>\n<!-- I don\'t think we get this cancelled var -->\n';
 if (canceled === 1) { 
__p+='<span class="less-likely">CANCELED</span>\n';
 } else { 
__p+='\n  <ul>\n    <li>Date: '+
((__t=( date_text ))==null?'':_.escape(__t))+
', '+
((__t=( time ))==null?'':_.escape(__t))+
'</li>\n    <li>Location: '+
((__t=( location ))==null?'':_.escape(__t))+
'</li>\n    ';
 if (agenda_link) { 
__p+='\n      <li><a href="'+
((__t=( agenda_link ))==null?'':_.escape(__t))+
'" target="_blank"><i class="fa-regular fa-file-lines"></i>Agenda</a></li>\n    ';
 } 
__p+='\n  </ul>\n';
 } 
__p+='';
}
return __p;
};
